import {  signupLegalUser } from '@/api/api'
import { pathes } from '@/routing/pathes'
import { OtpContext } from '@/shahrzad-assets/shared-hooks/OtpContext'
import { useRequest } from 'ahooks'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const useSignupLegalUser = () => {
    const navigate = useNavigate()
    const { setTraceNo, setUserPhoneNumber } = useContext(OtpContext);
    const [signupError, setSignupError] = useState<boolean>(false)

    const { run: fetchSignupLegalUser, loading: signupLoading } = useRequest(signupLegalUser, {
        manual: true,
        onSuccess(data) {
            setTraceNo(data.traceNo)
            navigate(`${pathes.LOGIN_OTP}/?type=legal`)
        },
        onError(error: any) {
            if (error?.response?.status === 400) {
                setSignupError(true)
            }
        },
    })

   

    return {
        signupLoading,
        signupError,
        fetchSignupLegalUser,
    }
}

export default useSignupLegalUser
